module.exports = __webpack_public_path__ + "static/media/txt.264168e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/txt.png
// module id = 240
// module chunks = 0